export default {
  offer: {
    id: 'buyback_swap_offer',
    defaultMessage: 'Buyback offer',
  },
  noFromProduct: {
    id: 'swap_buyback_purposal_no_from_product_ad_subtitle',
    defaultMessage: 'Return to the product',
  },
  noFromCart: {
    id: 'swap_buyback_purposal_no_from_cart_ad_subtitle',
    defaultMessage: 'Return to the cart',
  },
  no: {
    id: 'swap_buyback_purposal_no_subtitle',
    defaultMessage: 'Go to cart',
  },
  questionsTitle: {
    id: 'buyback_swap_details_request_title',
    defaultMessage: "Let's estimate the value of your device",
  },
  closeLabel: {
    id: 'swap_modal_close',
    defaultMessage: 'Close',
  },
}
